var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _g2, _g3, _g4, _path18, _g5, _g6, _g7, _g8, _g9, _path19, _path20, _path21, _g0, _g1, _path22, _path23, _path24, _g10, _g11, _path25, _path26, _path27, _path28, _path29, _g12, _g13, _g14, _g15, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g16, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3687 19.2266C12.7812 19.2266 6.61865 25.3766 6.61865 32.9766V37.3516H34.1062V32.9766C34.1062 25.3766 27.9562 19.2266 20.3687 19.2266Z",
    fill: "#56436B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3687 19.2266C12.7812 19.2266 6.61865 25.3766 6.61865 32.9766V37.3516H34.1062V32.9766C34.1062 25.3766 27.9562 19.2266 20.3687 19.2266Z",
    fill: "url(#paint0_radial_1522_4576)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3687 19.2266C12.7812 19.2266 6.61865 25.3766 6.61865 32.9766V37.3516H34.1062V32.9766C34.1062 25.3766 27.9562 19.2266 20.3687 19.2266Z",
    fill: "url(#paint1_radial_1522_4576)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.159 22.4331C29.2074 22.3341 29.1833 22.215 29.1001 22.1426C26.7765 20.1203 23.6482 19.0039 20.3721 19.0039C17.096 19.0039 13.9491 20.1322 11.6248 22.143C11.5414 22.2152 11.517 22.3342 11.5652 22.4334C13.153 25.7029 16.2624 28.2422 20.3721 28.2422C24.4818 28.2422 27.5606 25.7028 29.159 22.4331Z",
    fill: "url(#paint2_radial_1522_4576)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.159 22.4331C29.2074 22.3341 29.1833 22.215 29.1001 22.1426C26.7765 20.1203 23.6482 19.0039 20.3721 19.0039C17.096 19.0039 13.9491 20.1322 11.6248 22.143C11.5414 22.2152 11.517 22.3342 11.5652 22.4334C13.153 25.7029 16.2624 28.2422 20.3721 28.2422C24.4818 28.2422 27.5606 25.7028 29.159 22.4331Z",
    fill: "url(#paint3_radial_1522_4576)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.159 22.4331C29.2074 22.3341 29.1833 22.215 29.1001 22.1426C26.7765 20.1203 23.6482 19.0039 20.3721 19.0039C17.096 19.0039 13.9491 20.1322 11.6248 22.143C11.5414 22.2152 11.517 22.3342 11.5652 22.4334C13.153 25.7029 16.2624 28.2422 20.3721 28.2422C24.4818 28.2422 27.5606 25.7028 29.159 22.4331Z",
    fill: "url(#paint4_radial_1522_4576)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.159 22.4331C29.2074 22.3341 29.1833 22.215 29.1001 22.1426C26.7765 20.1203 23.6482 19.0039 20.3721 19.0039C17.096 19.0039 13.9491 20.1322 11.6248 22.143C11.5414 22.2152 11.517 22.3342 11.5652 22.4334C13.153 25.7029 16.2624 28.2422 20.3721 28.2422C24.4818 28.2422 27.5606 25.7028 29.159 22.4331Z",
    fill: "url(#paint5_radial_1522_4576)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.159 22.4331C29.2074 22.3341 29.1833 22.215 29.1001 22.1426C26.7765 20.1203 23.6482 19.0039 20.3721 19.0039C17.096 19.0039 13.9491 20.1322 11.6248 22.143C11.5414 22.2152 11.517 22.3342 11.5652 22.4334C13.153 25.7029 16.2624 28.2422 20.3721 28.2422C24.4818 28.2422 27.5606 25.7028 29.159 22.4331Z",
    fill: "url(#paint6_radial_1522_4576)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.159 22.4331C29.2074 22.3341 29.1833 22.215 29.1001 22.1426C26.7765 20.1203 23.6482 19.0039 20.3721 19.0039C17.096 19.0039 13.9491 20.1322 11.6248 22.143C11.5414 22.2152 11.517 22.3342 11.5652 22.4334C13.153 25.7029 16.2624 28.2422 20.3721 28.2422C24.4818 28.2422 27.5606 25.7028 29.159 22.4331Z",
    fill: "url(#paint7_radial_1522_4576)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4059 14.8891C26.8266 14.8755 27.2205 14.7329 27.541 14.502V15.6702C27.541 16.7909 26.8733 17.7893 25.8584 18.2036C26.0721 17.7486 26.219 17.2528 26.2924 16.723L26.4059 14.8891Z",
    fill: "url(#paint8_radial_1522_4576)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4059 14.8891C26.8266 14.8755 27.2205 14.7329 27.541 14.502V15.6702C27.541 16.7909 26.8733 17.7893 25.8584 18.2036C26.0721 17.7486 26.219 17.2528 26.2924 16.723L26.4059 14.8891Z",
    fill: "url(#paint9_radial_1522_4576)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.201 14.8911C13.7804 14.8775 13.3864 14.7348 13.0659 14.5039V15.6721C13.0659 16.7928 13.7336 17.7913 14.7485 18.2056C14.5348 17.7505 14.388 17.2547 14.3145 16.7249L14.201 14.8911Z",
    fill: "url(#paint10_radial_1522_4576)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.201 14.8911C13.7804 14.8775 13.3864 14.7348 13.0659 14.5039V15.6721C13.0659 16.7928 13.7336 17.7913 14.7485 18.2056C14.5348 17.7505 14.388 17.2547 14.3145 16.7249L14.201 14.8911Z",
    fill: "url(#paint11_radial_1522_4576)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9955 23.4379C20.0741 23.4917 20.2077 23.5379 20.3455 23.5427C20.4833 23.5379 20.6169 23.4917 20.6955 23.4379C21.9666 22.568 22.9205 21.7014 22.9205 20.2047V15.6629C22.9205 14.2379 21.7705 13.0879 20.3455 13.0879C18.9205 13.0879 17.7705 14.2379 17.7705 15.6629V20.2047C17.7705 21.7014 18.7244 22.568 19.9955 23.4379Z",
    fill: "url(#paint12_radial_1522_4576)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2473 16.7925C14.5703 19.2431 16.6558 21.0677 19.1247 21.0677H21.4928C23.9618 21.0677 26.0473 19.2431 26.3702 16.7925C26.5183 14.4281 26.6672 12.0731 26.7771 9.70993C26.7637 8.74718 26.0048 7.95275 25.0461 7.91235H23.2886C22.0902 7.91235 21.0051 7.20544 20.5124 6.10131C20.3859 5.78488 20.0797 5.57617 19.7402 5.57617H18.1424C15.8256 5.57617 13.9482 7.47473 13.9482 9.81764C13.9482 12.1533 14.0941 14.451 14.2473 16.7925Z",
    fill: "url(#paint13_radial_1522_4576)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2473 16.7925C14.5703 19.2431 16.6558 21.0677 19.1247 21.0677H21.4928C23.9618 21.0677 26.0473 19.2431 26.3702 16.7925C26.5183 14.4281 26.6672 12.0731 26.7771 9.70993C26.7637 8.74718 26.0048 7.95275 25.0461 7.91235H23.2886C22.0902 7.91235 21.0051 7.20544 20.5124 6.10131C20.3859 5.78488 20.0797 5.57617 19.7402 5.57617H18.1424C15.8256 5.57617 13.9482 7.47473 13.9482 9.81764C13.9482 12.1533 14.0941 14.451 14.2473 16.7925Z",
    fill: "url(#paint14_radial_1522_4576)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2473 16.7925C14.5703 19.2431 16.6558 21.0677 19.1247 21.0677H21.4928C23.9618 21.0677 26.0473 19.2431 26.3702 16.7925C26.5183 14.4281 26.6672 12.0731 26.7771 9.70993C26.7637 8.74718 26.0048 7.95275 25.0461 7.91235H23.2886C22.0902 7.91235 21.0051 7.20544 20.5124 6.10131C20.3859 5.78488 20.0797 5.57617 19.7402 5.57617H18.1424C15.8256 5.57617 13.9482 7.47473 13.9482 9.81764C13.9482 12.1533 14.0941 14.451 14.2473 16.7925Z",
    fill: "url(#paint15_radial_1522_4576)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2473 16.7925C14.5703 19.2431 16.6558 21.0677 19.1247 21.0677H21.4928C23.9618 21.0677 26.0473 19.2431 26.3702 16.7925C26.5183 14.4281 26.6672 12.0731 26.7771 9.70993C26.7637 8.74718 26.0048 7.95275 25.0461 7.91235H23.2886C22.0902 7.91235 21.0051 7.20544 20.5124 6.10131C20.3859 5.78488 20.0797 5.57617 19.7402 5.57617H18.1424C15.8256 5.57617 13.9482 7.47473 13.9482 9.81764C13.9482 12.1533 14.0941 14.451 14.2473 16.7925Z",
    fill: "url(#paint16_radial_1522_4576)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2473 16.7925C14.5703 19.2431 16.6558 21.0677 19.1247 21.0677H21.4928C23.9618 21.0677 26.0473 19.2431 26.3702 16.7925C26.5183 14.4281 26.6672 12.0731 26.7771 9.70993C26.7637 8.74718 26.0048 7.95275 25.0461 7.91235H23.2886C22.0902 7.91235 21.0051 7.20544 20.5124 6.10131C20.3859 5.78488 20.0797 5.57617 19.7402 5.57617H18.1424C15.8256 5.57617 13.9482 7.47473 13.9482 9.81764C13.9482 12.1533 14.0941 14.451 14.2473 16.7925Z",
    fill: "url(#paint17_radial_1522_4576)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2473 16.7925C14.5703 19.2431 16.6558 21.0677 19.1247 21.0677H21.4928C23.9618 21.0677 26.0473 19.2431 26.3702 16.7925C26.5183 14.4281 26.6672 12.0731 26.7771 9.70993C26.7637 8.74718 26.0048 7.95275 25.0461 7.91235H23.2886C22.0902 7.91235 21.0051 7.20544 20.5124 6.10131C20.3859 5.78488 20.0797 5.57617 19.7402 5.57617H18.1424C15.8256 5.57617 13.9482 7.47473 13.9482 9.81764C13.9482 12.1533 14.0941 14.451 14.2473 16.7925Z",
    fill: "url(#paint18_radial_1522_4576)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6931 12.6704L18.8964 14.9771C18.7603 15.4516 19.0869 15.9261 19.5497 15.9261H20.5364C20.9992 15.9261 21.3258 15.4443 21.1897 14.9771L20.5228 12.6704C20.3799 12.1594 19.8429 12.1594 19.6931 12.6704Z",
    fill: "#EE9020"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8235 12.4243L19.1566 14.7311C19.0205 15.2056 19.3472 15.6801 19.8099 15.6801H20.7967C21.2594 15.6801 21.5861 15.1983 21.45 14.7311L20.7831 12.4243C20.6402 11.9133 19.9733 11.9133 19.8235 12.4243Z",
    fill: "url(#paint19_linear_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8235 12.4243L19.1566 14.7311C19.0205 15.2056 19.3472 15.6801 19.8099 15.6801H20.7967C21.2594 15.6801 21.5861 15.1983 21.45 14.7311L20.7831 12.4243C20.6402 11.9133 19.9733 11.9133 19.8235 12.4243Z",
    fill: "url(#paint20_linear_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8235 12.4243L19.1566 14.7311C19.0205 15.2056 19.3472 15.6801 19.8099 15.6801H20.7967C21.2594 15.6801 21.5861 15.1983 21.45 14.7311L20.7831 12.4243C20.6402 11.9133 19.9733 11.9133 19.8235 12.4243Z",
    fill: "url(#paint21_linear_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8235 12.4243L19.1566 14.7311C19.0205 15.2056 19.3472 15.6801 19.8099 15.6801H20.7967C21.2594 15.6801 21.5861 15.1983 21.45 14.7311L20.7831 12.4243C20.6402 11.9133 19.9733 11.9133 19.8235 12.4243Z",
    fill: "url(#paint22_linear_1522_4576)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5991 16.4792L18.5991 16.4792C19.0912 16.7358 19.6781 16.883 20.3034 16.883C20.9351 16.883 21.5156 16.7358 22.0078 16.4792L22.0085 16.4788L22.0085 16.4789C22.1268 16.4187 22.2511 16.4536 22.3258 16.5312C22.4014 16.6096 22.4292 16.7356 22.3534 16.8495M18.5991 16.4792L22.2909 16.8081M18.5991 16.4792L18.5984 16.4789C18.479 16.4182 18.3546 16.4561 18.2807 16.5339C18.2065 16.612 18.1768 16.7382 18.2538 16.85M18.5991 16.4792L18.316 16.8081M22.3534 16.8495C22.3534 16.8496 22.3533 16.8496 22.3533 16.8497L22.2909 16.8081M22.3534 16.8495C22.3534 16.8495 22.3535 16.8494 22.3535 16.8494L22.2909 16.8081M22.3534 16.8495C21.9195 17.507 21.1638 17.9449 20.3034 17.9449C19.4433 17.9449 18.6878 17.5072 18.2538 16.85M22.2909 16.8081C21.8705 17.4452 21.1379 17.8699 20.3034 17.8699C19.469 17.8699 18.7364 17.4452 18.316 16.8081M18.2538 16.85C18.254 16.8503 18.2542 16.8505 18.2544 16.8508L18.316 16.8081M18.2538 16.85C18.2537 16.8498 18.2535 16.8496 18.2534 16.8494L18.316 16.8081",
    stroke: "url(#paint23_radial_1522_4576)",
    strokeWidth: 0.15
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3034 16.958C19.6664 16.958 19.0677 16.8081 18.5644 16.5457C18.3924 16.4583 18.2077 16.6519 18.316 16.8081C18.7364 17.4452 19.469 17.8699 20.3034 17.8699C21.1379 17.8699 21.8705 17.4452 22.2909 16.8081C22.3992 16.6456 22.2145 16.4583 22.0425 16.5457C21.5392 16.8081 20.9468 16.958 20.3034 16.958Z",
    fill: "url(#paint24_radial_1522_4576)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3975 4.98386C27.0433 5.20603 27.6225 5.65711 27.9886 6.30343C28.5745 7.3335 28.4879 8.56555 27.8555 9.47444C27.6358 9.7976 27.516 10.1814 27.516 10.5718V12.0631C27.2812 11.8995 26.9714 11.7783 26.6785 11.7265L26.777 9.71008C26.7637 8.74733 26.0047 7.95289 25.0461 7.9125H23.2885C22.0902 7.9125 21.005 7.20558 20.5124 6.10145C20.3859 5.78503 20.0796 5.57632 19.7401 5.57632H18.1423C15.8256 5.57632 13.9482 7.47488 13.9482 9.8178L13.9866 11.7475C13.6678 11.7943 13.3348 11.9009 13.0827 12.0785V10.5718C13.0827 10.1814 12.9629 9.7976 12.7432 9.47444C12.144 8.59248 12.0375 7.40756 12.5634 6.40442C12.9296 5.71097 13.5221 5.22623 14.1945 4.99059C14.9135 4.73475 15.526 4.25001 15.9321 3.59696C16.4514 2.76886 17.3634 2.43164 18.4086 2.43164C18.8147 2.43164 19.2009 2.51916 19.5604 2.66728C20.0397 2.87599 20.5789 2.87599 21.0583 2.66728C21.4111 2.51916 21.7973 2.43164 22.2034 2.43164C23.2619 2.43164 24.1873 2.78906 24.6999 3.63736C25.086 4.27694 25.6918 4.74149 26.3975 4.98386Z",
    fill: "url(#paint25_linear_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3975 4.98386C27.0433 5.20603 27.6225 5.65711 27.9886 6.30343C28.5745 7.3335 28.4879 8.56555 27.8555 9.47444C27.6358 9.7976 27.516 10.1814 27.516 10.5718V12.0631C27.2812 11.8995 26.9714 11.7783 26.6785 11.7265L26.777 9.71008C26.7637 8.74733 26.0047 7.95289 25.0461 7.9125H23.2885C22.0902 7.9125 21.005 7.20558 20.5124 6.10145C20.3859 5.78503 20.0796 5.57632 19.7401 5.57632H18.1423C15.8256 5.57632 13.9482 7.47488 13.9482 9.8178L13.9866 11.7475C13.6678 11.7943 13.3348 11.9009 13.0827 12.0785V10.5718C13.0827 10.1814 12.9629 9.7976 12.7432 9.47444C12.144 8.59248 12.0375 7.40756 12.5634 6.40442C12.9296 5.71097 13.5221 5.22623 14.1945 4.99059C14.9135 4.73475 15.526 4.25001 15.9321 3.59696C16.4514 2.76886 17.3634 2.43164 18.4086 2.43164C18.8147 2.43164 19.2009 2.51916 19.5604 2.66728C20.0397 2.87599 20.5789 2.87599 21.0583 2.66728C21.4111 2.51916 21.7973 2.43164 22.2034 2.43164C23.2619 2.43164 24.1873 2.78906 24.6999 3.63736C25.086 4.27694 25.6918 4.74149 26.3975 4.98386Z",
    fill: "url(#paint26_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3975 4.98386C27.0433 5.20603 27.6225 5.65711 27.9886 6.30343C28.5745 7.3335 28.4879 8.56555 27.8555 9.47444C27.6358 9.7976 27.516 10.1814 27.516 10.5718V12.0631C27.2812 11.8995 26.9714 11.7783 26.6785 11.7265L26.777 9.71008C26.7637 8.74733 26.0047 7.95289 25.0461 7.9125H23.2885C22.0902 7.9125 21.005 7.20558 20.5124 6.10145C20.3859 5.78503 20.0796 5.57632 19.7401 5.57632H18.1423C15.8256 5.57632 13.9482 7.47488 13.9482 9.8178L13.9866 11.7475C13.6678 11.7943 13.3348 11.9009 13.0827 12.0785V10.5718C13.0827 10.1814 12.9629 9.7976 12.7432 9.47444C12.144 8.59248 12.0375 7.40756 12.5634 6.40442C12.9296 5.71097 13.5221 5.22623 14.1945 4.99059C14.9135 4.73475 15.526 4.25001 15.9321 3.59696C16.4514 2.76886 17.3634 2.43164 18.4086 2.43164C18.8147 2.43164 19.2009 2.51916 19.5604 2.66728C20.0397 2.87599 20.5789 2.87599 21.0583 2.66728C21.4111 2.51916 21.7973 2.43164 22.2034 2.43164C23.2619 2.43164 24.1873 2.78906 24.6999 3.63736C25.086 4.27694 25.6918 4.74149 26.3975 4.98386Z",
    fill: "url(#paint27_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3975 4.98386C27.0433 5.20603 27.6225 5.65711 27.9886 6.30343C28.5745 7.3335 28.4879 8.56555 27.8555 9.47444C27.6358 9.7976 27.516 10.1814 27.516 10.5718V12.0631C27.2812 11.8995 26.9714 11.7783 26.6785 11.7265L26.777 9.71008C26.7637 8.74733 26.0047 7.95289 25.0461 7.9125H23.2885C22.0902 7.9125 21.005 7.20558 20.5124 6.10145C20.3859 5.78503 20.0796 5.57632 19.7401 5.57632H18.1423C15.8256 5.57632 13.9482 7.47488 13.9482 9.8178L13.9866 11.7475C13.6678 11.7943 13.3348 11.9009 13.0827 12.0785V10.5718C13.0827 10.1814 12.9629 9.7976 12.7432 9.47444C12.144 8.59248 12.0375 7.40756 12.5634 6.40442C12.9296 5.71097 13.5221 5.22623 14.1945 4.99059C14.9135 4.73475 15.526 4.25001 15.9321 3.59696C16.4514 2.76886 17.3634 2.43164 18.4086 2.43164C18.8147 2.43164 19.2009 2.51916 19.5604 2.66728C20.0397 2.87599 20.5789 2.87599 21.0583 2.66728C21.4111 2.51916 21.7973 2.43164 22.2034 2.43164C23.2619 2.43164 24.1873 2.78906 24.6999 3.63736C25.086 4.27694 25.6918 4.74149 26.3975 4.98386Z",
    fill: "url(#paint28_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3975 4.98386C27.0433 5.20603 27.6225 5.65711 27.9886 6.30343C28.5745 7.3335 28.4879 8.56555 27.8555 9.47444C27.6358 9.7976 27.516 10.1814 27.516 10.5718V12.0631C27.2812 11.8995 26.9714 11.7783 26.6785 11.7265L26.777 9.71008C26.7637 8.74733 26.0047 7.95289 25.0461 7.9125H23.2885C22.0902 7.9125 21.005 7.20558 20.5124 6.10145C20.3859 5.78503 20.0796 5.57632 19.7401 5.57632H18.1423C15.8256 5.57632 13.9482 7.47488 13.9482 9.8178L13.9866 11.7475C13.6678 11.7943 13.3348 11.9009 13.0827 12.0785V10.5718C13.0827 10.1814 12.9629 9.7976 12.7432 9.47444C12.144 8.59248 12.0375 7.40756 12.5634 6.40442C12.9296 5.71097 13.5221 5.22623 14.1945 4.99059C14.9135 4.73475 15.526 4.25001 15.9321 3.59696C16.4514 2.76886 17.3634 2.43164 18.4086 2.43164C18.8147 2.43164 19.2009 2.51916 19.5604 2.66728C20.0397 2.87599 20.5789 2.87599 21.0583 2.66728C21.4111 2.51916 21.7973 2.43164 22.2034 2.43164C23.2619 2.43164 24.1873 2.78906 24.6999 3.63736C25.086 4.27694 25.6918 4.74149 26.3975 4.98386Z",
    fill: "url(#paint29_radial_1522_4576)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9883 9.58162C24.7684 9.39016 24.5128 9.18728 24.1255 9.06537C23.7438 8.94519 23.2656 8.91291 22.6041 8.99384C22.4133 9.01718 22.2776 9.19075 22.301 9.38152C22.3243 9.57229 22.4979 9.70801 22.6886 9.68468C23.2924 9.61081 23.6623 9.64919 23.9166 9.72924C24.1654 9.80757 24.3337 9.93447 24.5311 10.1064C24.6761 10.2327 24.8959 10.2175 25.0221 10.0726C25.1483 9.92767 25.1332 9.70785 24.9883 9.58162Z",
    fill: "#C05029"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0223 9.44583C16.1353 9.37814 16.2981 9.29156 16.5035 9.21077C16.9144 9.04921 17.5016 8.90891 18.2043 8.99487C18.3951 9.01821 18.5308 9.19178 18.5074 9.38255C18.4841 9.57332 18.3105 9.70904 18.1198 9.68571C17.5571 9.61687 17.0877 9.72895 16.7582 9.85849C16.5935 9.92324 16.4651 9.99188 16.3797 10.043C16.337 10.0685 16.3053 10.0896 16.2854 10.1033C16.2755 10.1102 16.2685 10.1152 16.2646 10.1181L16.2612 10.1207C16.1095 10.2376 15.8917 10.21 15.774 10.0587C15.656 9.90701 15.6833 9.68837 15.835 9.57038L16.0223 9.44583Z",
    fill: "#C05029"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5951 6.27293C20.5659 6.21683 20.5382 6.15957 20.5121 6.10121C20.3856 5.78478 20.0794 5.57607 19.7399 5.57607H18.1421C15.8253 5.57607 13.9479 7.47464 13.9479 9.81755V10.1629C13.5212 9.83816 12.9844 9.15306 12.9844 8.04437C12.9844 6.69899 13.9656 6.01894 14.5915 5.58516C14.7682 5.46269 14.9166 5.35986 15.0066 5.26722C15.0448 5.22786 15.0865 5.18372 15.1317 5.13571C15.5705 4.67037 16.3522 3.84125 17.7173 3.4789C18.4707 3.27891 19.2353 3.24952 19.8165 3.27957C20.2887 3.304 20.6216 3.71216 20.6216 4.18501V6.25605L20.5951 6.27293Z",
    fill: "url(#paint30_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5951 6.27293C20.5659 6.21683 20.5382 6.15957 20.5121 6.10121C20.3856 5.78478 20.0794 5.57607 19.7399 5.57607H18.1421C15.8253 5.57607 13.9479 7.47464 13.9479 9.81755V10.1629C13.5212 9.83816 12.9844 9.15306 12.9844 8.04437C12.9844 6.69899 13.9656 6.01894 14.5915 5.58516C14.7682 5.46269 14.9166 5.35986 15.0066 5.26722C15.0448 5.22786 15.0865 5.18372 15.1317 5.13571C15.5705 4.67037 16.3522 3.84125 17.7173 3.4789C18.4707 3.27891 19.2353 3.24952 19.8165 3.27957C20.2887 3.304 20.6216 3.71216 20.6216 4.18501V6.25605L20.5951 6.27293Z",
    fill: "url(#paint31_radial_1522_4576)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8467 10.5052L26.8101 9.71292C26.7968 8.75461 26.0048 7.96384 25.0462 7.92363H23.2886C22.1729 7.92363 21.1553 7.31365 20.6227 6.3425C20.6227 6.3425 20.4728 5.99548 20.3767 5.44365C20.2046 4.45546 21.1208 3.72654 22.1102 3.89148C23.4259 4.11082 25.0379 4.53746 26.1929 5.29081C28.3827 6.71907 27.9993 9.29307 26.8467 10.5052Z",
    fill: "url(#paint32_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8467 10.5052L26.8101 9.71292C26.7968 8.75461 26.0048 7.96384 25.0462 7.92363H23.2886C22.1729 7.92363 21.1553 7.31365 20.6227 6.3425C20.6227 6.3425 20.4728 5.99548 20.3767 5.44365C20.2046 4.45546 21.1208 3.72654 22.1102 3.89148C23.4259 4.11082 25.0379 4.53746 26.1929 5.29081C28.3827 6.71907 27.9993 9.29307 26.8467 10.5052Z",
    fill: "url(#paint33_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8467 10.5052L26.8101 9.71292C26.7968 8.75461 26.0048 7.96384 25.0462 7.92363H23.2886C22.1729 7.92363 21.1553 7.31365 20.6227 6.3425C20.6227 6.3425 20.4728 5.99548 20.3767 5.44365C20.2046 4.45546 21.1208 3.72654 22.1102 3.89148C23.4259 4.11082 25.0379 4.53746 26.1929 5.29081C28.3827 6.71907 27.9993 9.29307 26.8467 10.5052Z",
    fill: "url(#paint34_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8467 10.5052L26.8101 9.71292C26.7968 8.75461 26.0048 7.96384 25.0462 7.92363H23.2886C22.1729 7.92363 21.1553 7.31365 20.6227 6.3425C20.6227 6.3425 20.4728 5.99548 20.3767 5.44365C20.2046 4.45546 21.1208 3.72654 22.1102 3.89148C23.4259 4.11082 25.0379 4.53746 26.1929 5.29081C28.3827 6.71907 27.9993 9.29307 26.8467 10.5052Z",
    fill: "url(#paint35_radial_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8467 10.5052L26.8101 9.71292C26.7968 8.75461 26.0048 7.96384 25.0462 7.92363H23.2886C22.1729 7.92363 21.1553 7.31365 20.6227 6.3425C20.6227 6.3425 20.4728 5.99548 20.3767 5.44365C20.2046 4.45546 21.1208 3.72654 22.1102 3.89148C23.4259 4.11082 25.0379 4.53746 26.1929 5.29081C28.3827 6.71907 27.9993 9.29307 26.8467 10.5052Z",
    fill: "url(#paint36_radial_1522_4576)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3041 11.2324C24.1237 11.2324 24.816 11.7974 25.0043 12.561C25.0603 12.7799 24.8923 12.9886 24.6683 12.9886H21.8687C21.6905 12.9886 21.548 12.8257 21.5836 12.6475C21.7414 11.8433 22.449 11.2324 23.3041 11.2324Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0444 11.5742C23.6654 11.5742 24.1642 12.0782 24.1642 12.6941C24.1642 12.7959 24.149 12.8977 24.1235 12.9893H21.9602C21.9347 12.8926 21.9194 12.7959 21.9194 12.6941C21.9194 12.0782 22.4234 11.5742 23.0444 11.5742Z",
    fill: "url(#paint37_radial_1522_4576)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4033 12.6937C22.4033 12.3376 22.6882 12.0527 23.0443 12.0527C23.4004 12.0527 23.6852 12.3376 23.6852 12.6937C23.6852 12.8005 23.6598 12.9023 23.614 12.9887H22.4796C22.4288 12.9023 22.4033 12.8005 22.4033 12.6937Z",
    fill: "black"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9615 11.811C23.0412 11.9176 22.8746 12.0476 22.6852 12.1892C22.4958 12.3308 22.3553 12.4304 22.2756 12.3238C22.1959 12.2173 22.2849 12.0161 22.4743 11.8745C22.6637 11.7329 22.8818 11.7045 22.9615 11.811Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9615 11.811C23.0412 11.9176 22.8746 12.0476 22.6852 12.1892C22.4958 12.3308 22.3553 12.4304 22.2756 12.3238C22.1959 12.2173 22.2849 12.0161 22.4743 11.8745C22.6637 11.7329 22.8818 11.7045 22.9615 11.811Z",
    fill: "url(#paint38_radial_1522_4576)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0413 12.5442C24 12.2553 23.831 12.0376 23.7516 11.9648L23.4263 12.322L23.5731 12.6077L24.0413 12.5442Z",
    fill: "url(#paint39_linear_1522_4576)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3019 11.2324C16.4823 11.2324 15.79 11.7975 15.6017 12.5611C15.5457 12.7799 15.7137 12.9887 15.9376 12.9887H18.7374C18.9156 12.9887 19.0582 12.8258 19.0225 12.6476C18.8647 11.8433 18.152 11.2324 17.3019 11.2324Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5618 11.5723C16.9408 11.5723 16.4419 12.0762 16.4419 12.6922C16.4419 12.794 16.4572 12.8958 16.4826 12.9874H18.6461C18.6716 12.8907 18.6868 12.794 18.6868 12.6922C18.6817 12.0762 18.1829 11.5723 17.5618 11.5723Z",
    fill: "url(#paint40_radial_1522_4576)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 12.6937C18.2024 12.3376 17.9175 12.0527 17.5614 12.0527C17.2053 12.0527 16.9204 12.3376 16.9204 12.6937C16.9204 12.8006 16.9458 12.9023 16.9916 12.9888H18.1261C18.1719 12.9023 18.2024 12.8006 18.2024 12.6937Z",
    fill: "black"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5837 12.5594C18.5837 12.1983 18.2901 11.9575 18.2107 11.8848L17.8496 12.234L18.0718 12.6863L18.5837 12.5594Z",
    fill: "url(#paint41_linear_1522_4576)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.223,
    cy: 12.0523,
    rx: 0.488329,
    ry: 0.247139,
    transform: "rotate(-27.914 17.223 12.0523)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.223,
    cy: 12.0523,
    rx: 0.488329,
    ry: 0.247139,
    transform: "rotate(-27.914 17.223 12.0523)",
    fill: "url(#paint42_radial_1522_4576)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4819 15.0058C26.5645 13.67 26.6442 12.3358 26.7136 11C27.662 11.1659 28.3829 11.9935 28.3829 12.9894C28.3829 14.065 27.5421 14.9443 26.4819 15.0058Z",
    fill: "url(#paint43_linear_1522_4576)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4819 15.0058C26.5645 13.67 26.6442 12.3358 26.7136 11C27.662 11.1659 28.3829 11.9935 28.3829 12.9894C28.3829 14.065 27.5421 14.9443 26.4819 15.0058Z",
    fill: "url(#paint44_radial_1522_4576)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4819 15.0058C26.5645 13.67 26.6442 12.3358 26.7136 11C27.662 11.1659 28.3829 11.9935 28.3829 12.9894C28.3829 14.065 27.5421 14.9443 26.4819 15.0058Z",
    fill: "url(#paint45_radial_1522_4576)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9598 10.9902C12.9791 11.1285 12.2246 11.9712 12.2246 12.9901C12.2246 14.0684 13.0696 14.9494 14.1336 15.0069C14.0526 13.6656 13.9858 12.3319 13.9598 10.9902Z",
    fill: "url(#paint46_linear_1522_4576)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9598 10.9902C12.9791 11.1285 12.2246 11.9712 12.2246 12.9901C12.2246 14.0684 13.0696 14.9494 14.1336 15.0069C14.0526 13.6656 13.9858 12.3319 13.9598 10.9902Z",
    fill: "url(#paint47_radial_1522_4576)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9799 11.8184C13.4445 11.9384 13.0444 12.4166 13.0444 12.9882C13.0444 13.5965 13.4975 14.0989 14.0846 14.1766C14.0411 13.3901 14.0044 12.605 13.9799 11.8184Z",
    fill: "#DD8224"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5322 14.1872C26.5806 13.391 26.6274 12.5951 26.671 11.7988C27.2624 11.8726 27.7199 12.3771 27.7199 12.9884C27.7199 13.6468 27.1892 14.1812 26.5322 14.1872Z",
    fill: "#FFC837"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0693 9.79598C16.3918 9.56462 17.1956 9.15765 18.1463 9.3175",
    stroke: "#C96953",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7744 9.73934C24.4519 9.50798 23.6481 9.10101 22.6975 9.26086",
    stroke: "#C96953",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2788 14.4419V3.36328H30.2788V14.4419H31.2788Z",
    fill: "url(#paint48_linear_1522_4576)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2788 14.4419V3.36328H30.2788V14.4419H31.2788Z",
    fill: "url(#paint49_radial_1522_4576)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5708 6.41602L14.1382 3.92578L26.3257 3.78906L28.0249 6.36719C22.1948 8.37891 15.1831 7.33398 12.5708 6.41602Z",
    fill: "url(#paint50_radial_1522_4576)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2911 4.36328H10.3286C9.77861 4.36328 9.32861 3.91328 9.32861 3.36328C9.32861 2.81328 9.77861 2.36328 10.3286 2.36328H30.2786C30.8286 2.36328 31.2786 2.81328 31.2786 3.36328C31.2911 3.91328 30.8411 4.36328 30.2911 4.36328Z",
    fill: "url(#paint51_linear_1522_4576)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2911 4.36328H10.3286C9.77861 4.36328 9.32861 3.91328 9.32861 3.36328C9.32861 2.81328 9.77861 2.36328 10.3286 2.36328H30.2786C30.8286 2.36328 31.2786 2.81328 31.2786 3.36328C31.2911 3.91328 30.8411 4.36328 30.2911 4.36328Z",
    fill: "url(#paint52_radial_1522_4576)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2911 4.36328H10.3286C9.77861 4.36328 9.32861 3.91328 9.32861 3.36328C9.32861 2.81328 9.77861 2.36328 10.3286 2.36328H30.2786C30.8286 2.36328 31.2786 2.81328 31.2786 3.36328C31.2911 3.91328 30.8411 4.36328 30.2911 4.36328Z",
    fill: "url(#paint53_radial_1522_4576)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2783 14.4121C29.9528 14.5897 29.7319 14.935 29.7319 15.3319C29.7319 15.9102 30.2007 16.3789 30.779 16.3789C31.3572 16.3789 31.826 15.9102 31.826 15.3319C31.826 14.935 31.6051 14.5897 31.2796 14.4121H30.2783Z",
    fill: "url(#paint54_radial_1522_4576)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2783 14.4121C29.9528 14.5897 29.7319 14.935 29.7319 15.3319C29.7319 15.9102 30.2007 16.3789 30.779 16.3789C31.3572 16.3789 31.826 15.9102 31.826 15.3319C31.826 14.935 31.6051 14.5897 31.2796 14.4121H30.2783Z",
    fill: "url(#paint55_radial_1522_4576)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9077 4.49219V14.2016",
    stroke: "url(#paint56_linear_1522_4576)",
    strokeWidth: 0.15
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7119 16.8634L29.0664 19.6616C28.9844 20.017 29.2572 20.3553 29.622 20.3505H31.9509C32.3126 20.3457 32.5758 20.0056 32.4898 19.6542L31.8117 16.8552C31.7432 16.5756 31.4925 16.3789 31.2046 16.3789H30.3209C30.0298 16.3789 29.7773 16.5798 29.7119 16.8634Z",
    fill: "url(#paint57_linear_1522_4576)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7119 16.8634L29.0664 19.6616C28.9844 20.017 29.2572 20.3553 29.622 20.3505H31.9509C32.3126 20.3457 32.5758 20.0056 32.4898 19.6542L31.8117 16.8552C31.7432 16.5756 31.4925 16.3789 31.2046 16.3789H30.3209C30.0298 16.3789 29.7773 16.5798 29.7119 16.8634Z",
    fill: "url(#paint58_radial_1522_4576)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7119 16.8634L29.0664 19.6616C28.9844 20.017 29.2572 20.3553 29.622 20.3505H31.9509C32.3126 20.3457 32.5758 20.0056 32.4898 19.6542L31.8117 16.8552C31.7432 16.5756 31.4925 16.3789 31.2046 16.3789H30.3209C30.0298 16.3789 29.7773 16.5798 29.7119 16.8634Z",
    fill: "url(#paint59_radial_1522_4576)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7119 16.8634L29.0664 19.6616C28.9844 20.017 29.2572 20.3553 29.622 20.3505H31.9509C32.3126 20.3457 32.5758 20.0056 32.4898 19.6542L31.8117 16.8552C31.7432 16.5756 31.4925 16.3789 31.2046 16.3789H30.3209C30.0298 16.3789 29.7773 16.5798 29.7119 16.8634Z",
    fill: "url(#paint60_radial_1522_4576)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3255 37.35V22.6172C8.44168 25.1367 6.61865 28.8414 6.61865 32.975V37.35H11.3255Z",
    fill: "url(#paint61_radial_1522_4576)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3255 37.35V22.6172C8.44168 25.1367 6.61865 28.8414 6.61865 32.975V37.35H11.3255Z",
    fill: "url(#paint62_radial_1522_4576)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3255 37.35V22.6172C8.44168 25.1367 6.61865 28.8414 6.61865 32.975V37.35H11.3255Z",
    fill: "url(#paint63_linear_1522_4576)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3996 37.35V22.6172C32.2834 25.1367 34.1064 28.8414 34.1064 32.975V37.35H29.3996Z",
    fill: "url(#paint64_radial_1522_4576)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3996 37.35V22.6172C32.2834 25.1367 34.1064 28.8414 34.1064 32.975V37.35H29.3996Z",
    fill: "url(#paint65_radial_1522_4576)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_1522_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9473 29.5702C14.9473 29.3351 15.1407 29.1445 15.3794 29.1445C15.6181 29.1445 15.8115 29.3351 15.8115 29.5702V37.1865H14.9473V29.5702Z",
    fill: "url(#paint66_linear_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9302 29.5702C19.9302 29.3351 20.1236 29.1445 20.3623 29.1445C20.601 29.1445 20.7944 29.3351 20.7944 29.5702V37.1865H19.9302V29.5702Z",
    fill: "url(#paint67_linear_1522_4576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9131 29.5702C24.9131 29.3351 25.1066 29.1445 25.3452 29.1445C25.5839 29.1445 25.7773 29.3351 25.7773 29.5702V37.1865H24.9131V29.5702Z",
    fill: "url(#paint68_linear_1522_4576)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1522_4576",
    x: 13.9482,
    y: 5.57617,
    width: 13.3286,
    height: 15.6922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823529 0 0 0 0 0.623529 0 0 0 0 0.313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1522_4576"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.54902 0 0 0 0 0.0941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1522_4576",
    result: "effect2_innerShadow_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1522_4576",
    x: 17.8652,
    y: 11.2871,
    width: 4.35547,
    height: 5.63867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1522_4576",
    x: 19.0255,
    y: 11.941,
    width: 2.55547,
    height: 3.83867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1522_4576",
    x: 18.0333,
    y: 16.273,
    width: 4.53984,
    height: 1.84648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_1522_4576",
    x: 12.2246,
    y: 1.93164,
    width: 16.1582,
    height: 10.1465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.509804 0 0 0 0 0.0627451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1522_4576"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.486275 0 0 0 0 0.0470588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1522_4576",
    result: "effect2_innerShadow_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1522_4576",
    x: 22.2983,
    y: 8.74922,
    width: 2.90957,
    height: 1.44219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.603922 0 0 0 0 0.243137 0 0 0 0 0.152941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1522_4576",
    x: 15.7007,
    y: 8.76875,
    width: 2.90957,
    height: 1.42461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.603922 0 0 0 0 0.243137 0 0 0 0 0.152941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1522_4576",
    x: 12.7344,
    y: 3.01953,
    width: 8.13721,
    height: 7.39258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1522_4576",
    x: 20.106,
    y: 3.61719,
    width: 7.91943,
    height: 7.13867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1522_4576",
    x: 22.1466,
    y: 11.6461,
    width: 0.935352,
    height: 0.823047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1522_4576",
    x: 23.2263,
    y: 11.7648,
    width: 1.01523,
    height: 1.04258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1522_4576",
    x: 17.6496,
    y: 11.6848,
    width: 1.13389,
    height: 1.20078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1522_4576",
    x: 16.6764,
    y: 11.6363,
    width: 1.09355,
    height: 0.832813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1522_4576",
    x: 12.7944,
    y: 11.5684,
    width: 1.54004,
    height: 2.85742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_1522_4576",
    x: 26.2822,
    y: 11.5488,
    width: 1.6875,
    height: 2.88867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_1522_4576",
    x: 15.6943,
    y: 8.90625,
    width: 2.82715,
    height: 1.26562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_1522_4576",
    x: 22.3223,
    y: 8.84961,
    width: 2.82715,
    height: 1.26562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_1522_4576",
    x: 30.5825,
    y: 4.24219,
    width: 0.650391,
    height: 10.209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_1522_4576",
    x: 14.7973,
    y: 28.9945,
    width: 11.1301,
    height: 8.34297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_1522_4576"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4895 28.7508) rotate(90) scale(13.5938 4.57031)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70647F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70647F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2473 26.6805) scale(1.64062 8.82813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D516A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D516A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3721 26.543) rotate(-90) scale(5.89844 17.0659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47404D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2D3A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3623 20.9766) rotate(90) scale(7.42188 9.42757)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.931579,
    stopColor: "#342542",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994737,
    stopColor: "#342542"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.841 19.2969) rotate(145.631) scale(8.90887 12.2824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9281,
    stopColor: "#6A656F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A656F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5285 19.0039) rotate(34.2663) scale(10.2332 14.1083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.933129,
    stopColor: "#6A656F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615B67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3623 29.375) rotate(-90) scale(12.5781 13.3067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.506211,
    stopColor: "#57525D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57525D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3623 19.0039) rotate(90) scale(4.82422 6.30257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.316364,
    stopColor: "#361E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361E27",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2676 14.502) rotate(103.169) scale(4.80465 5.70755)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0431525,
    stopColor: "#FFC135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26839"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3317 14.8385) rotate(53.9017) scale(0.624718 0.530708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E18C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E18C2A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3393 14.6511) rotate(71.2338) scale(5.19963 2.36347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D57A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D06A3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1701 14.6406) rotate(72.2903) scale(1.31368 1.15237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.263377,
    stopColor: "#BE691E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977292,
    stopColor: "#BE691E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1069 22.8317) rotate(-135.444) scale(1.78163 3.76597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF7B39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8279 13.3219) rotate(180) scale(6.56209 11.6083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A129"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9742 10.1561) rotate(94.7148) scale(11.4058 13.0726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.623188,
    stopColor: "#FBA036",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979213,
    stopColor: "#C56B42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7771 13.0311) rotate(93.7745) scale(7.67588 2.82197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.389903,
    stopColor: "#FFD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD930",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6785 11.8402) rotate(-90) scale(1.7747 2.13665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276316,
    stopColor: "#F59632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59632",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4274 11.3236) rotate(-90) scale(1.92706 2.49946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.178218,
    stopColor: "#FFBE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5314 5.57617) rotate(90) scale(3.10297 7.93318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.633626,
    stopColor: "#E28222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1522_4576",
    x1: 20.3033,
    y1: 14.3609,
    x2: 21.376,
    y2: 14.3609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1522_4576",
    x1: 18.9572,
    y1: 14.1657,
    x2: 20.305,
    y2: 14.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E88830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49F22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1522_4576",
    x1: 20.3033,
    y1: 14.8613,
    x2: 20.3033,
    y2: 15.9302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E88830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844655,
    stopColor: "#E88830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1522_4576",
    x1: 20.3033,
    y1: 12.041,
    x2: 20.3033,
    y2: 12.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC137",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8891 17.4506) rotate(-60.732) scale(0.891323 2.59378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB534",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3034 17.7647) rotate(-90) scale(0.90468 3.63976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89014E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87004D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1522_4576",
    x1: 27.0361,
    y1: 6.21422,
    x2: 14.3285,
    y2: 6.21422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29935"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7394 11.3363) rotate(-90) scale(7.17855 12.719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314517,
    stopColor: "#C98537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C98537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.405 11.3363) rotate(-90) scale(4.55977 8.07901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4582 3.4581) rotate(-160.666) scale(5.46263 2.90921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.347073,
    stopColor: "#FFE639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE639",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1675 1.45939) rotate(58.4652) scale(2.17223 5.02986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286771,
    stopColor: "#F3C130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C130",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6216 3.26953) rotate(160.16) scale(5.08004 1.41389)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4867 9.2436) rotate(-57.7244) scale(7.56471 8.38092)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0926981,
    stopColor: "#D67227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233498,
    stopColor: "#EF8A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8A23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8482 4.72538) rotate(13.3074) scale(4.36716 2.44241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7417 10.5052) rotate(-120.119) scale(5.3746 2.99737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB8F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8F29",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9633 10.1284) rotate(-120.695) scale(3.21475 2.30259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394122,
    stopColor: "#E48421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E48421",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3209 4.57878) rotate(166.509) scale(6.19398 6.69593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.734853,
    stopColor: "#F29415",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29415"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6378 4.42172) rotate(107.002) scale(0.503678 2.30275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.461072,
    stopColor: "#FFCE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0418 12.1728) rotate(90) scale(1.01806 1.61933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7552 12.2779) rotate(-127.812) scale(0.474122 0.652753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1522_4576",
    x1: 24.0175,
    y1: 12.2386,
    x2: 23.6247,
    y2: 12.4807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5644 12.1709) rotate(90) scale(1.01811 1.61942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1522_4576",
    x1: 18.4967,
    y1: 12.2379,
    x2: 18.1039,
    y2: 12.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2041 12.447) rotate(-90.897) scale(0.61933 0.74446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1522_4576",
    x1: 28.3829,
    y1: 12.2741,
    x2: 26.8681,
    y2: 15.0058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC136"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1001 12.19) rotate(74.3475) scale(2.92424 2.78995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.856273,
    stopColor: "#E1943D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08F2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5525 12.8737) rotate(-53.9198) scale(1.67908 1.4074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663731,
    stopColor: "#FFBD22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1522_4576",
    x1: 12.961,
    y1: 13.1584,
    x2: 14.7914,
    y2: 12.9985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9851D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6973 12.401) rotate(101.248) scale(2.65689 2.61197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77507,
    stopColor: "#C77937",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1522_4576",
    x1: 29.9751,
    y1: 11.0341,
    x2: 31.4577,
    y2: 11.0341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61546D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0813 14.4419) rotate(-90) scale(2.91842 0.225393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70635D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70635D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8257 7.52026) rotate(-102.428) scale(4.90072 26.1455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1522_4576",
    x1: 22.5755,
    y1: 4.80469,
    x2: 20.974,
    y2: -0.664062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D294B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5365 2.85156) rotate(90) scale(1.17188 15.8594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#696070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.82553 3.63281) scale(9.6875 1.09375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75707B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935484,
    stopColor: "#75707B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4042 14.9061) rotate(126.437) scale(1.71017 1.53271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661286,
    stopColor: "#402A4C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7319 15.3955) rotate(-6.43681) scale(1.00176 1.17496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0866887,
    stopColor: "#685352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685352",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1522_4576",
    x1: 31.4077,
    y1: 4.49219,
    x2: 31.4077,
    y2: 14.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60546C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1522_4576",
    x1: 32.2181,
    y1: 18.3647,
    x2: 29.3191,
    y2: 18.3647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89726,
    stopColor: "#FAAC28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3571 18.213) rotate(169.33) scale(1.39415 6.95501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285799,
    stopColor: "#FFD93A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD93A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.779 20.9765) rotate(-90) scale(1.64062 3.61304)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.421677,
    stopColor: "#A16739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9820",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.779 16.2402) rotate(90) scale(0.498047 1.72721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16129,
    stopColor: "#845D03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA429",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.61865 37.35) rotate(-90) scale(20.4667 5.4558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441285,
    stopColor: "#58496A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4159"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3255 37.35) rotate(-90) scale(13.1502 1.03016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285977,
    stopColor: "#4F445B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F445B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1522_4576",
    x1: 11.5057,
    y1: 34.936,
    x2: 10.974,
    y2: 34.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.444444,
    stopColor: "#433850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433850",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.753 37.35) rotate(-100.465) scale(12.9569 3.63912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#736782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F5070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_1522_4576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1891 28.8019) rotate(87.4134) scale(15.0571 0.879347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176695,
    stopColor: "#3F2A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2A51",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1522_4576",
    x1: 20.3623,
    y1: 37.1865,
    x2: 20.3623,
    y2: 29.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1522_4576",
    x1: 20.3623,
    y1: 37.1865,
    x2: 20.3623,
    y2: 29.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1522_4576",
    x1: 20.3623,
    y1: 37.1865,
    x2: 20.3623,
    y2: 29.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3748",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentEmoji);
export default __webpack_public_path__ + "static/media/StudentEmoji.523565857ee442c2c983fa3ac42a5b55.svg";
export { ForwardRef as ReactComponent };